import { OmsReport } from "../lusca-search-api/generated-src";

function sourceIdentity(report: OmsReport) {
  return JSON.stringify([
    report.product,
    report.snapshotId,
    report.sourceRefreshedAt,
    report.exportedAt,
    report.rowCount,
    report.totalBytes,
    report.columns,
    report.parts,
  ]);
}

export default function refreshOmsReportMetadata(
  pinned: OmsReport,
  available: OmsReport
): OmsReport {
  // Suggestions may improve without changing the source accepted by an export.
  if (sourceIdentity(pinned) !== sourceIdentity(available)) return pinned;
  const columnTypes = { ...pinned.columnTypes, ...available.columnTypes };
  const columnValues = { ...pinned.columnValues };
  Object.entries(available.columnValues || {}).forEach(([name, choices]) => {
    const previous = columnValues[name];
    if (
      !previous ||
      choices.complete ||
      (!previous.complete && choices.values.length >= previous.values.length)
    )
      columnValues[name] = choices;
  });
  if (
    JSON.stringify(columnTypes) === JSON.stringify(pinned.columnTypes || {}) &&
    JSON.stringify(columnValues) === JSON.stringify(pinned.columnValues || {})
  )
    return pinned;
  return { ...pinned, columnTypes, columnValues };
}
